import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { gapi, errMsg, fmtDateTime } from "../api";
import { AuthShell, Field, Submit, Notice, PASSWORD_HINT } from "../components/AuthShell";

export default function Invito() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ nome: "", telefono: "", password: "", password2: "" });
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    gapi.get(`/auth/invite/${encodeURIComponent(token)}`).then((r) => { setInfo(r.data); setForm((f) => ({ ...f, nome: r.data.nome || "" })); })
      .catch((e) => setError(errMsg(e, "Invito non valido")));
  }, [token]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password2) return setError("Le password non coincidono");
    setLoading(true); setError("");
    try {
      await gapi.post("/auth/invite/accept", { token, nome: form.nome, telefono: form.telefono, password: form.password });
      setDone(true);
    } catch (e2) { setError(errMsg(e2)); } finally { setLoading(false); }
  };

  if (done) return (
    <AuthShell title="Account creato" testid="g-invite-done">
      <Notice kind="ok">Il tuo accesso è pronto.</Notice>
      <Link to="/gestionale/accesso" className="block text-center rounded-full bg-brand text-white font-semibold py-3.5" data-testid="g-invite-go-login">Accedi al gestionale</Link>
    </AuthShell>
  );

  return (
    <AuthShell title="Invito al gestionale" subtitle={info ? `Ruolo: ${info.ruoloLabel} · scade il ${fmtDateTime(info.scadeIl)}` : ""} testid="g-invite-form">
      {error && <Notice testid="g-invite-error">{error}</Notice>}
      {info && (
        <form onSubmit={submit}>
          <Field label="Email" value={info.email} disabled />
          <Field label="Nome e cognome" value={form.nome} onChange={set("nome")} required data-testid="g-invite-nome" />
          <Field label="Telefono (facoltativo)" value={form.telefono} onChange={set("telefono")} data-testid="g-invite-telefono" />
          <Field label="Password" type="password" value={form.password} onChange={set("password")} autoComplete="new-password" required data-testid="g-invite-password" />
          <Field label="Ripeti password" type="password" value={form.password2} onChange={set("password2")} autoComplete="new-password" required data-testid="g-invite-password2" />
          <p className="text-xs text-anthracite/50 -mt-2 mb-5">{PASSWORD_HINT}</p>
          <Submit loading={loading} data-testid="g-invite-submit">Crea il mio accesso</Submit>
        </form>
      )}
    </AuthShell>
  );
}
